export default __webpack_public_path__ + "static/media/elvania.8a6420b0.png";